<template>
  <ModalDialog
    ref="dialog"
    title="NCR item details"
    icon="fa-repeat"
    sizeClass='modal-med'
    :submitting="submitting"
    :submitTitle="submitTitle"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="ncrForm" :labelColumnSize="3">
      <FormRow :label="isNCRSetup ? 'Remake Quantity' : 'Quantity'" :suffix="quantitySuffix">
        <FormInputText ref="quantityEntry" type="number" v-model="quantity" />
      </FormRow>
      <FormRow label="Repair Quantity" :suffix="quantitySuffix" v-if="isNCRSetup">
        <FormInputText ref="repairQuantityEntry" type="number" v-model="repairQuantity" />
      </FormRow>
      <FormRow label="NCR Reason">
        <FormInputTextArea ref="textEntryArea" v-model="ncrRequestReason" placeholder="Enter reason for adding this item for a non-chargeable rework" field="ncrRequestReason" />
      </FormRow>
      <FormRow label="Labels">
        <FormLabelTag v-model="ncrLabelList" labelType="orderItemNCR" field="ncrLabelList" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: "OrderActionDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    originalQuantity: Number,
    orderItem: Object,
    submitTitle: String,
    submitPromise: Function,
    isNCRSetup: Boolean,
    isNewOrder: Boolean
  },
  data() {
    return {
      submitting: false,
      ncrRequestReason: '',
      quantity: 0,
      repairQuantity: 0,
      ncrLabelList: [],
      ncrForm: {}
    }
  },
  mounted() {
    // Fill in details from existing item
    if(this.orderItem) {
      this.quantity = this.orderItem.quantity
      this.ncrRequestReason = this.orderItem.ncrRequestReason
      this.ncrLabelList = this.orderItem.ncrLabelList
    }

    this.$nextTick(() => {
      this.$refs.quantityEntry.focus()
      this.$refs.quantityEntry.select()
    })
  },
  computed: {
    quantitySuffix() {
      if(this.originalQuantity <= 0 || !this.isNewOrder)
        return ''
      return ` / ${this.originalQuantity}`
    }
  },
  methods: {
    show(params) {
      this.ncrForm = {}
      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.ncrForm = {}

      if(parseInt(this.quantity) + parseInt(this.repairQuantity) <= 0) {
        this.$data.ncrForm = this.processFormResponse('Quantity must be at least 1')
        return
      }
      if(this.isNewOrder) {
        if(parseInt(this.quantity) +  parseInt(this.repairQuantity) > this.originalQuantity) {
          this.$data.ncrForm = this.processFormResponse('Total quantity cannot be more than the original quantity')
          return
        }
      }
      if(this.ncrRequestReason == '') {
        this.$data.ncrForm = this.processFormResponse('NCR Request reason must be set')
        return
      }

      this.submitting = true
      this.submitPromise({
        ncrRequestReason: this.ncrRequestReason,
        quantity: parseInt(this.quantity),
        repairQuantity: parseInt(this.repairQuantity),
        ncrLabelList: this.ncrLabelList
      })
      .then(() => {
        this.submitting = false
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.ncrForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>